import React from "react";
import "./style.scss";

interface ImageWrapperProps {
  src: string;
  alt: string;
}

const ImageWrapper = ({
  src,
  alt,
  ...props
}: ImageWrapperProps): JSX.Element => {
  return (
    <div className="img-wrapper">
      <div {...props}>
        <img src={src} alt={alt} className="img-wrapper__img" />
      </div>
    </div>
  );
};

export default ImageWrapper;
